/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLanguageTranslations200ResponseItemsInner } from './GetLanguageTranslations200ResponseItemsInner';
import {
    GetLanguageTranslations200ResponseItemsInnerFromJSON,
    GetLanguageTranslations200ResponseItemsInnerFromJSONTyped,
    GetLanguageTranslations200ResponseItemsInnerToJSON,
    GetLanguageTranslations200ResponseItemsInnerToJSONTyped,
} from './GetLanguageTranslations200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetLanguageTranslations200Response
 */
export interface GetLanguageTranslations200Response {
    /**
     * 
     * @type {Array<GetLanguageTranslations200ResponseItemsInner>}
     * @memberof GetLanguageTranslations200Response
     */
    items: Array<GetLanguageTranslations200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLanguageTranslations200Response
     */
    total: number;
}

/**
 * Check if a given object implements the GetLanguageTranslations200Response interface.
 */
export function instanceOfGetLanguageTranslations200Response(value: object): value is GetLanguageTranslations200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetLanguageTranslations200ResponseFromJSON(json: any): GetLanguageTranslations200Response {
    return GetLanguageTranslations200ResponseFromJSONTyped(json, false);
}

export function GetLanguageTranslations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLanguageTranslations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetLanguageTranslations200ResponseItemsInnerFromJSON)),
        'total': json['total'],
    };
}

export function GetLanguageTranslations200ResponseToJSON(json: any): GetLanguageTranslations200Response {
    return GetLanguageTranslations200ResponseToJSONTyped(json, false);
}

export function GetLanguageTranslations200ResponseToJSONTyped(value?: GetLanguageTranslations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetLanguageTranslations200ResponseItemsInnerToJSON)),
        'total': value['total'],
    };
}

